/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAPIKeysSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAPIKeysRequest = {
  /**
   * When set, list keys for this first-class agent
   */
  agentId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAPIKeysSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAPIKeysSecurity$outboundSchema: z.ZodMiniType<
  ListAPIKeysSecurity$Outbound,
  ListAPIKeysSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAPIKeysSecurityToJSON(
  listAPIKeysSecurity: ListAPIKeysSecurity,
): string {
  return JSON.stringify(
    ListAPIKeysSecurity$outboundSchema.parse(listAPIKeysSecurity),
  );
}

/** @internal */
export type ListAPIKeysRequest$Outbound = {
  agent_id?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAPIKeysRequest$outboundSchema: z.ZodMiniType<
  ListAPIKeysRequest$Outbound,
  ListAPIKeysRequest
> = z.pipe(
  z.object({
    agentId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAPIKeysRequestToJSON(
  listAPIKeysRequest: ListAPIKeysRequest,
): string {
  return JSON.stringify(
    ListAPIKeysRequest$outboundSchema.parse(listAPIKeysRequest),
  );
}
